import React from "react";
import { UStyles } from "@/app/utils/UStyles";
import styles from "./PageWrapper.module.css";

type Props = {
  title: React.ReactNode;
  subtitle?: string;
  rightElement?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
  maxWidth?: string;
};

export default function PageWrapper(props: Props) {
  const { title, subtitle, rightElement, children, className, contentClassName, maxWidth } = props;

  return (
    <div className={styles.container}>
      <div
        className={UStyles.classNames(styles.frame, className)}
        style={maxWidth ? { maxWidth } : undefined}
      >
        <div className={styles.header}>
          <div className={styles.titles}>
            <h1 className={styles.title}>{title}</h1>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
          </div>

          {rightElement && <div className={styles.rightElement}>{rightElement}</div>}
        </div>

        <div className={UStyles.classNames(styles.content, contentClassName)}>{children}</div>
      </div>
    </div>
  );
}
